import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { FormHelper } from '../../../../shared/helpers/form.helper';

@Pipe({
  name: 'controlHasRequired',
  standalone: true,
  pure: false,
})
export class ControlHasRequiredPipe implements PipeTransform {
  transform(control: AbstractControl): boolean {
    return this.hasRequiredField(control);
  }

  private hasRequiredField(abstractControl: AbstractControl): boolean {
    if (!abstractControl || abstractControl?.disabled) {
      return false;
    }

    if (abstractControl.validator) {
      if (FormHelper.hasRequiredValidator(abstractControl)) {
        return true;
      }
    }

    if (abstractControl['controls']) {
      for (const controlName in abstractControl['controls']) {
        if (abstractControl['controls'][controlName]) {
          if (this.hasRequiredField(abstractControl['controls'][controlName])) {
            return true;
          }
        }
      }
    }

    return false;
  }
}
